import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout/Layout';
import defaultTheme from './theme/default';
import { ThemeProvider } from '@mui/material/styles';

// Routes
// Project archived: only the home page remains. The download pages
// (mainnet/testnet/snapshot) have been removed so the site no longer
// surfaces snapshot instructions or fetches remote manifests.
import Home from './views/home';

export default function App() {
	return (
		<ThemeProvider theme={defaultTheme}>
			<BrowserRouter>
				<Routes>
					<Route path='/' element={<Layout />}>
						<Route index element={<Home />} />
						{/* Any old deep-link redirects to the archived landing page */}
						<Route path='*' element={<Navigate to='/' replace />} />
					</Route>
				</Routes>
			</BrowserRouter>
		</ThemeProvider>
	);
}
